var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.25 0C1.00781 0 0 0.839844 0 1.875C0 2.46484 0.332813 3.01953 0.9 3.375L11.1 9.75C11.6344 10.082 12.3656 10.082 12.9 9.75L23.1 3.375C23.6672 3.01953 24 2.46484 24 1.875C24 0.839844 22.9922 0 21.75 0H2.25ZM0 4.375V12.5C0 13.8789 1.34531 15 3 15H21C22.6547 15 24 13.8789 24 12.5V4.375L13.8 10.75C12.7312 11.418 11.2688 11.418 10.2 10.75L0 4.375Z",
    fill: "#E3B505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.861981271a29addc7498a213eb4af6a9.svg";
export { ForwardRef as ReactComponent };